import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Link, Snackbar } from '@mui/material';
import { styled } from '@mui/system';
import { setSnackbar } from '../redux/features/snackbarSlice';
import {
  ERROR_FILLED, INFO_FILLED, SANS_STACK, SUCCESS_FILLED, WARNING_FILLED,
} from './common/tokens';

const StyledAlert = styled(Alert)({
  borderRadius: 4,
  fontFamily: SANS_STACK,
  fontSize: 14,
  fontWeight: 500,
  color: '#fff',
  alignItems: 'center',
  padding: '4px 14px',
  boxShadow: '0 4px 16px rgba(0,0,0,0.16), 0 2px 6px rgba(0,0,0,0.1)',
  '& .MuiAlert-icon': { color: '#fff', opacity: 1, marginRight: 10 },
  '& .MuiAlert-action': { color: '#fff', paddingTop: 0, alignItems: 'center' },
  '&.MuiAlert-filledSuccess': { backgroundColor: SUCCESS_FILLED },
  '&.MuiAlert-filledError': { backgroundColor: ERROR_FILLED },
  '&.MuiAlert-filledWarning': { backgroundColor: WARNING_FILLED },
  '&.MuiAlert-filledInfo': { backgroundColor: INFO_FILLED },
});

function ListSnackbar() {
  const dispatch = useDispatch();
  const snackbarOpen = useSelector((state) => state.snackbar.snackbarOpen);
  const snackbarType = useSelector((state) => state.snackbar.snackbarType);
  const snackbarMessage = useSelector((state) => state.snackbar.snackbarMessage);
  const snackbarLink = useSelector((state) => state.snackbar.snackbarLink);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(setSnackbar({
      snackbarOpen: false,
      snackbarType,
      snackbarMessage,
    }));
  };

  return (
    <Snackbar
      autoHideDuration={snackbarLink ? null : 3000}
      open={snackbarOpen}
      onClose={handleClose}
    >
      <StyledAlert
        severity={snackbarType}
        elevation={0}
        variant="filled"
        onClose={handleClose}
      >
        {snackbarMessage}
        {snackbarLink && (
          <>
            {' '}
            <Link
              component={RouterLink}
              to={snackbarLink.to}
              onClick={handleClose}
              color="inherit"
              sx={{ fontWeight: 700, textDecorationColor: 'inherit' }}
            >
              {snackbarLink.text}
            </Link>
          </>
        )}
      </StyledAlert>
    </Snackbar>
  );
}

export default ListSnackbar;
